import { toNumber } from '@develop/ia-utils'
import { PageType } from '@/models/pages'
import type { PharmacyDetails } from '@/models/pharmacy-details'

export const ensurePharmacyPageNavigation = async (pharmacy: PharmacyDetails) => {
  const route = useRoute()

  const isProductPage = route.meta.type === PageType.Product
  const isPharmacyPage = route.meta.type === PageType.Pharmacy

  const { pharmacyId: urlPharmacyIdString } = route.params as { pharmacyId?: string }
  if (urlPharmacyIdString) {
    const urlPharmacyId = toNumber(urlPharmacyIdString)

    if (urlPharmacyId) {
      const idMatches = urlPharmacyId === pharmacy.id

      if (idMatches)
        return

      if (isPharmacyPage)
        return navigateToPharmacyPage(pharmacy)

      if (isProductPage) {
        const { pzn, productName } = useRoute('pharmacyName-pharmacyPlz-pharmacyId-produkt-productName-pzn').params
        const { getProductRoute } = useRouteUtils()

        const pharmacyProductRoute = getProductRoute({ pzn, productName }, pharmacy)

        return customNavigateTo(pharmacyProductRoute)
      }

      // navigate to same page with selected pharmacy id
      return customNavigateTo({
        name: route.name as any,
        params: {
          ...route.params,
          pharmacyId: pharmacy.id,
        },
      })
    }
  }
}
